/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/iconsAlert/index.tsx
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import React from 'react'

import Icon from '@ant-design/icons'

import {
  IconConfirm,
  IconError,
  IconInfo,
  IconSuccess,
  IconUser,
  IconWarning,
} from '../../assets/svg'

interface TypesAlerts {
  type: 'success' | 'info' | 'warning' | 'confirm' | 'error' | 'user'
  // eslint-disable-next-line react/require-default-props
  size?: number
}

export const IconAlert: React.FC<TypesAlerts> = (props) => {
  const { type, size = 42 } = props
  let tipo
  switch (type) {
    case 'success':
      tipo = <IconSuccess size={size} />
      break
    case 'info':
      tipo = <IconInfo size={size} />
      break
    case 'warning':
      tipo = <IconWarning size={size} />
      break
    case 'confirm':
      tipo = <IconConfirm size={size} />
      break
    case 'error':
      tipo = <IconError size={size} />
      break
    case 'user':
      tipo = <IconUser size={size} />
      break
    default:
      tipo = null
      break
  }

  return <Icon component={() => tipo} />
}
